// src/ChangePassword.js
import React, { useState } from 'react';
import {
    Edit,
    SimpleForm,
    PasswordInput,
    required,
    useNotify,
    useRedirect,
    Toolbar,
    SaveButton,
} from 'react-admin';
import { Box, Typography } from '@mui/material';

const ChangePasswordToolbar = props => (
    <Toolbar {...props}>
        <SaveButton alwaysEnable />
    </Toolbar>
);

// Password requirements info box
const PasswordRequirements = () => (
    <Box sx={{ 
        mb: 2, 
        p: 2, 
        bgcolor: '#f5f5f5', 
        borderRadius: 1,
        border: '2px solid #E31837'
    }}>
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: '#E31837' }}>
            Wymagania dotyczące hasła:
        </Typography>
        <Typography variant="body2" component="ul" sx={{ m: 0, pl: 2, color: '#333333' }}>
            <li>Minimum 12 znaków</li>
            <li>Co najmniej jedna wielka litera (A-Z)</li>
            <li>Co najmniej jedna mała litera (a-z)</li>
            <li>Co najmniej jedna cyfra (0-9)</li>
            <li>Co najmniej jeden znak specjalny (!@#$%^&* itd.)</li>
            <li>Nie może być popularnym hasłem</li>
        </Typography>
    </Box>
);

const ChangePassword = props => {
    const notify = useNotify();
    const redirect = useRedirect();
    const [key, setKey] = useState(0);

    return (
        <Edit
            {...props}
            resource="my-account/change-password"
            id="current"
            mutationMode="pessimistic"
            mutationOptions={{
                onSuccess: () => {
                    notify('Hasło zostało zmienione pomyślnie', { type: 'success' });
                    // Force form reset by changing key
                    setKey(prev => prev + 1);
                    // Redirect to dashboard after 1.5 seconds
                    setTimeout(() => {
                        redirect('/');
                    }, 1500);
                },
                onError: (error) => {
                    // Display error message from validation
                    if (error.message) {
                        notify(error.message, { type: 'error', multiLine: true });
                    } else {
                        notify('Nie udało się zmienić hasła', { type: 'error' });
                    }
                },
            }}
            title="Zmiana hasła"
        >
            <SimpleForm key={key} toolbar={<ChangePasswordToolbar />} redirect={false}>
                <PasswordRequirements />
                <PasswordInput 
                    source="old_password" 
                    label="Obecne hasło" 
                    validate={required('Pole wymagane')} 
                    defaultValue="" 
                    fullWidth
                />
                <PasswordInput 
                    source="new_password" 
                    label="Nowe hasło" 
                    validate={required('Pole wymagane')} 
                    defaultValue="" 
                    fullWidth
                />
                <PasswordInput
                    source="confirm_password"
                    label="Potwierdź nowe hasło"
                    validate={[
                        required('Pole wymagane'),
                        (value, allValues) =>
                            value !== allValues.new_password
                                ? 'Hasła nie są takie same'
                                : undefined,
                    ]}
                    defaultValue=""
                    fullWidth
                />
            </SimpleForm>
        </Edit>
    );
};

export default ChangePassword;
